import { Avatar, ListItemText, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import { useDispatch, useSelector } from "react-redux";
import React, { useState } from "react";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import { Grid } from "@mui/material";
import { IReduxState } from "../../store";
import MenuApp from "./MenuApp";
import { SITEWEB_SERVER_BASE_URL } from "../../util/apiClient";



const Liste = () => {

  const dispatch = useDispatch();
  const { filteredEtablissements } = useSelector((state: IReduxState) => state.siteWeb);

  //hooks


  return (
    <>
      <div
        style={{
          padding: 10,
          height: "55vh",
          overflow: "auto",
        }}
      >

        <Box sx={{ flexGrow: 1, width: "100%" }}>
          <List dense={true}>
            {filteredEtablissements.map((item, i: number) => {
              return (
                <div key={i}>
                  <ListItem
                    secondaryAction={
                      <MenuApp
                        item={item}
                      />
                    }
                  >
                    <ListItem>
                      <ListItemIcon>
                        <Avatar alt="Pas d'image" src={`${SITEWEB_SERVER_BASE_URL}/etabLogoImage/${item?.libImageEtab}`} />
                      </ListItemIcon>

                      <ListItemButton>
                        <ListItemText
                          primary={item.libEtab}
                        />
                      </ListItemButton>
                    </ListItem>
                  </ListItem>
                  <Divider />
                </div>
              );
            })}
          </List>
        </Box>
      </div>
    </>
  );
};
export default Liste;
